/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getBookmark = /* GraphQL */ `
  query GetBookmark($id: ID!) {
    getBookmark(id: $id) {
      id
      userId
      createAt
      type
      search
      category
      country
      searchInTitle
      language
      sortBy
      source
      from
      to
      owner
    }
  }
`;
export const listBookmarks = /* GraphQL */ `
  query ListBookmarks(
    $filter: ModelBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookmarks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        createAt
        type
        search
        category
        country
        searchInTitle
        language
        sortBy
        source
        from
        to
        owner
      }
      nextToken
    }
  }
`;
export const getHistory = /* GraphQL */ `
  query GetHistory($id: ID!) {
    getHistory(id: $id) {
      id
      userId
      createAt
      type
      search
      category
      country
      searchInTitle
      language
      sortBy
      source
      from
      to
      owner
    }
  }
`;
export const listHistorys = /* GraphQL */ `
  query ListHistorys(
    $filter: ModelHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHistorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        createAt
        type
        search
        category
        country
        searchInTitle
        language
        sortBy
        source
        from
        to
        owner
      }
      nextToken
    }
  }
`;
